// extracted by mini-css-extract-plugin
export var compact = "_mq-2";
export var phoneFrame = "_mq-0";
export var phoneScreen = "_mq-1";